import { NavArrowDown, NavArrowUp } from 'iconoir-react';
import { omit } from 'lodash';
import { FC } from 'react';
import styled, { css } from 'styled-components';

const StyledDropdownIndicator = styled.div`
  padding-right: 16px;
  padding-left: 8px;
  box-sizing: border-box;
  position: relative;
  display: flex;
  ${props =>
    props.isFocused &&
    css`
      color: ${props => props.theme.colors.pri400} !important;
    `};
`;

interface DropdownIndicatorProps {
  selectProps: {
    menuIsOpen: boolean;
  };
  isFocused: boolean;
}

export const DropdownIndicator: FC<DropdownIndicatorProps> = props => {
  const { selectProps } = props;

  return (
    <StyledDropdownIndicator
      data-testid='dropdown'
      {...omit(props, ['theme', 'cx'])}
    >
      {selectProps.menuIsOpen ? <NavArrowUp /> : <NavArrowDown />}
    </StyledDropdownIndicator>
  );
};
